import {AboutPageProps, MetaTagsProps} from "@/types";
import {OG_PATH, WEBSITE_URL, BUSINESS_NAME} from "@/content";

export const metaTagsAbout : MetaTagsProps = {
    title: `${BUSINESS_NAME} - About Us`,
    description: `${BUSINESS_NAME} - Sydney electricians specialising in residential, commercial, and solar solutions. Learn about our mission to deliver safe, reliable, and energy-efficient electrical services across Sydney.`,
    keywords: "Powered Up Electrical, about Powered Up Electrical, Sydney electricians, electrical company Sydney, solar installers Sydney, residential electrical services, commercial electrical services",
    url: `${WEBSITE_URL}/about`,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const aboutPageContent : AboutPageProps = {
    title: `${BUSINESS_NAME} - About Us`,
    description: `${BUSINESS_NAME} - Sydney electricians specialising in residential, commercial, and solar solutions. Learn about our mission to deliver safe, reliable, and energy-efficient electrical services across Sydney.`,
    images: [],
}
